import classNames from 'classnames';
import { useMemo } from 'react';
import { Heading } from 'yoso/src/components/Text/Heading';
import { Adventure, useAdventure } from '~/components/Adventure/Adventure.hooks';
import { AdventureRewardCarousel } from '~/components/Adventure/Carousel/v2/AdventureRewardCarousel';
import { BaseError } from '~/components/Error/BaseError';
import { T } from '~/components/I18n/Translation';
import { format } from '~/components/Util/number';
import styles from './AdventureExplore.module.scss';

export type AdventureExploreProps = {
  id: Adventure['id'];
  className?: string;
};
export const AdventureExplore = ({ id, className }: AdventureExploreProps) => {
  const { data: { participation, rewardList = [] } = {}, isFetched } = useAdventure(id);
  const { overallCount = 0 } = participation || {};

  const lotteryRewards = useMemo(
    () => rewardList.filter((each) => each.rewardType === 'LOTTERY_NFT'),
    [rewardList]
  );
  if (isFetched && lotteryRewards.length === 0) throw new BaseError('EMPTY');

  return (
    <div className={classNames(styles.root, className)}>
      <div className={styles.header}>
        <Heading level={3} className={styles.heading}>
          <T name="citizen_adventure_join_title" options={[id]} />
        </Heading>
        <p className={styles.description}>
          <T name="citizen_adventure_join_desc" balance />
        </p>
        <div className={styles.count}>
          <T name="citizen_adventure_join_num_total" />
          <strong>
            {format(overallCount)}
            <T
              name="citizen_unit_number_of_trial"
              options={{ 0: overallCount, count: overallCount }}
            />
          </strong>
        </div>
      </div>
      <div className={styles.body}>
        <AdventureRewardCarousel id={id} />
      </div>
    </div>
  );
};
